import HCLDX from "@system/config/hcldx";
import System from "../../src/helper/system";
import $ from "jquery";
import Constants from "src/helper/Constants";

let c = System.getParams();

class Bom {
    //GUEST USER
    static GUEST_BOM_LISTING= System.getBOMUrl() + '/api/bom/guest/list';
    static Guest_CREATE_BOM = System.getBOMUrl() + '/api/bom/guest/create';
    static GUEST_LIST_PROJECT_DETAIL_WITH_BOM = System.getBOMUrl() + '/api/project/guestbomlist'
    static GUEST_ADD_PART_TO_BOM = System.getBOMUrl() + '/api/bom/guest/addpart'
    static GUEST_BOM_DETAIL_BY_BOM_ID_WITH_TYPE  = System.getBOMUrl() + '/api/bom/guest/detailsMatchType'
    static GUEST_BOM_UPLOAD_FILE = System.getBOMUrl() + '/api/bom/guest/bomUpload'
    static GUEST_CREATE_PART_LIST = System.getBOMUrl() + '/api/bom/guest/createpartlist'
    static GUEST_BOM_REMATCH_STATIC_COLUMN = System.getBOMUrl() + '/api/bom/guest/columns'
    static GUEST_BOM_SAVE_REMATCH_COLUMN_PREFERENCE = System.getBOMUrl() + '/api/bom/guest/finishcolumnmapping'

    //WEB-CORE USER
    static BOM_LISTING = System.getBOMUrl() + '/api/bom/list';
    static CREATE_BOM = System.getBOMUrl() + '/api/bom/create';
    static EDIT_BOM = System.getBOMUrl() + '/api/bom/edit';
    static ADD_PART_TO_BOM = System.getBOMUrl() + '/api/bom/addpart';
    static BOM_DETAIL_BY_BOM_ID = System.getBOMUrl() + '/api/bom/get'
    static BOM_DELETE_BY_BOM_ID = System.getBOMUrl() + '/api/bom/delete'
    static BOM_COPY_BY_BOM_ID = System.getBOMUrl() + '/api/bom/createcopy'
    static BOM_HEALTH_BY_BOM_ID = System.getBOMUrl() + '/api/bom/bomHealth'
    static BOM_DETAIL_BY_BOM_ID_WITH_TYPE = System.getBOMUrl() + '/api/bom/detailsMatchType'
    static UPDATE_BOM_DETAIL_QUANTITY_BY_BOM_DETAIL_ID = System.getBOMUrl() + '/api/bom/updatequantity'
    static UPDATE_BOM_DETAIL_CUSTOMER_PART_NUMBER_BY_BOM_DETAIL_ID = System.getBOMUrl() + '/api/bom/updatecpn'
    static DOWNLOAD_BOM_TEMPLATE = System.getBOMUrl() + '/api/bom/downloadBomTemplate'
    static BOM_UPLOAD_FILE = System.getBOMUrl() + '/api/bom/bomUpload'
    static BOM_UPLOAD_FILE_PROGRESS = System.getBOMUrl() + '/api/bom/bomUploadProcess'
    static BOM_DETAIL_ALTERNATIVE_COUNT_CALL = System.getApplicationUrl() + '/api/application/product/bomalternative'
    static BOM_DOWNLOAD_FILE = System.getBOMUrl() + '/api/bom/bomDownload'
    static BOM_EMAIL_FILE = System.getBOMUrl() + '/api/bom/emailBom';
    static CREATE_PART_LIST = System.getBOMUrl() + '/api/bom/createpartlist'
    static SWAP_PART_NUMBER = System.getBOMUrl() + '/api/bom/swappartnumber'
    static REMOVE_PART_NUMBER = System.getBOMUrl() + '/api/bom/removepart'
    static ASSIGN_BOM_TO_PROJECT = System.getBOMUrl() + '/api/project/assignbom'
    static CREATE_PROJECT = System.getBOMUrl() + '/api/project/create'
    static EDIT_PROJECT = System.getBOMUrl() + '/api/project/edit'
    static FETCH_SINGLE_PROJECT = System.getBOMUrl() + '/api/project/get'
    static DELETE_PROJECT = System.getBOMUrl() + '/api/project/delete'
    static LIST_PROJECT = System.getBOMUrl() + '/api/project/list'
    static LIST_PROJECT_DETAIL_WITH_BOM = System.getBOMUrl() + '/api/project/bomlist'
    static BOM_REMATCH_COLUMN_DATA = System.getBOMUrl() + '/api/bom/columndata'
    static BOM_REMATCH_STATIC_COLUMN = System.getBOMUrl() + '/api/bom/columns'
    static BOM_SAVED_REMATCH_COLUMN_PREFERENCE = System.getBOMUrl() + '/api/bom/getcolumns'
    static BOM_SAVE_REMATCH_COLUMN_PREFERENCE = System.getBOMUrl() + '/api/bom/finishcolumnmapping'
    static BOM_SET_IS_REMATCH_FLAG_IN_BOM_DETAIL = System.getBOMUrl() + '/api/bom/rematch'
    static BOM_MULTIPLE_MATCH_PRODUCT_SEARCH = System.getBOMUrl() + '/api/bom/multipleproducts'
    static UPDATE_DISPLAY_ORDER = System.getBOMUrl() + '/api/bom/updatedisplayorder'
    static UPDATE_BOM_PARTS = System.getBOMUrl() + '/api/bom/updateBomParts?action=movetocart'
    static BOM_Newark_LIST = System.getApplicationUrl() + '/api/newark/getnewarkproductsforbom'

    //User Based
    static FETCH_DOWNLOAD_BOM_PREFERENCE = System.getUserUrl() + '/api/user/getUserPreference'

    static getBomRouteURL() {
        return HCLDX.baseURL() + '/resources/myavnet/bom';
    }

    static getBomTabsListRouteURL(extra_c = {}) {
        c['__c'] = Constants.BomPages.BomTabsList.param_value;
        return this.getURLBasedOnParamKey({
            ...c,
            ...extra_c
        });
    }

    static getBomRematchRouteURL(extra_c = {}) {
        c['__c'] = Constants.BomPages.BomRematch.param_value;
        return this.getURLBasedOnParamKey({
            ...c,
            ...extra_c
        });
    }

    static getBomProductListingRouteURL(bomId, extra_c = {}) {
        c['__c'] = Constants.BomPages.BomProductListing.param_value;
        c['bomId'] = bomId;
        return this.getURLBasedOnParamKey({
            ...c,
            ...extra_c
        });
    }

    static getBomDetailByIdRouteURL(bomId, extra_c = {}) {
        c['__c'] = Constants.BomPages.BomDetailById.param_value;
        c['bomId'] = bomId;
        delete c['search']
        delete c['ComingFromUniversalSearch']
        return this.getURLBasedOnParamKey({
            ...c,
            ...extra_c
        });
    }

    static getURLBasedOnParamKey(c) {
        return HCLDX.baseURL() + '/resources/myavnet/bom?' + $.param(c);
    }
}

export default Bom;